import Axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import router from '@/router';
import SecureLS from 'secure-ls';

let ls = new SecureLS({
  isCompression: false,
});

// Shared axios factory for the credit-union-ussd-api-v2 backend. Both the
// autocredit and downstream-push admin surfaces live on this API, so they
// share one base URL and one auth/401 interceptor setup.
export const CuUssdApiRequest = (): AxiosInstance => {
  let baseHeader: AxiosInstance = Axios.create({
    baseURL: process.env.VUE_APP_AUTOCREDIT_BASE_URL,
    headers: {
      'x-channel-id': 'admin_web',
    },
    timeout: 80000,
  });

  baseHeader.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      config.headers.common['Accept'] = 'application/json';
      config.headers.common['Content-Type'] = 'application/json';
      // Guarded: JSON.parse throws on the empty string SecureLS returns for a
      // missing key, which would fail the request outright when logged out.
      let session: string | undefined;
      try {
        session = JSON.parse(ls.get('cloud.access'))?.auth?.user?.token;
        // eslint-disable-next-line no-empty
      } catch (e) {}
      if (session) {
        config.headers.common['authorization'] = `Bearer ${session}`;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    },
  );

  baseHeader.interceptors.response.use(
    (response: AxiosResponse) => {
      return Promise.resolve(response);
    },
    error => {
      if (error.response) {
        if (error.response.status === 401) {
          localStorage.clear();
          router.replace('/signin').then();
        }
      }
      return Promise.reject(error);
    },
  );
  return baseHeader;
};
